export default __webpack_public_path__ + "static/media/tiktok.1fc05034.svg";